import { ISlotsState } from "@/app_redux/reducers/slices/auth/slots_slice";
import useRouteInfo from "../../useRouteInfo";
import { useRouter } from "../../useRouter";
import { useBookedSlotsListAPI } from "../bookings/useBookedSlotsListAPI";

export const useRefetchBookedSlots = () => {
  const { getRouteKey } = useRouter();
  const { routeState } = useRouteInfo(getRouteKey("SLOTS", "id"));
  const { filters } = routeState.state as ISlotsState;
  const fetchBookedSlots = useBookedSlotsListAPI();

  const execute = () => {
    if (filters) {
      let copyFilters = filters;
      if (filters?.clinic_ids?.length > 0) {
        copyFilters = { ...copyFilters, city_id: null };
      }
      fetchBookedSlots({
        ...copyFilters,
        slot_status: "1",
      });
    }
  };
  return execute;
};
